import { createSvgComponent } from "../../icon/createSvgComponent";
import Share2 from "@core/__generated__/icon/figma/share-2.svg";
export default createSvgComponent(Share2);